<div class="container indent-background">
  <div class="row">
    <div class="col-12 description">
      INKfection Collection offers many different stock images. 
      To view and purchase a stock image please visit our Etsy store by clicking <a href="https://www.etsy.com/shop/INKfectionCollection" target="_new"><strong>HERE</strong></a>.
      <br>&nbsp;<br>
      Or if you have a cool tattoo yourself that you'd like to have transformed we can create custom work also. 
      We are working on allowing you to upload your images directly to the site, but in the meantime please 
      email you're image to <a href="mailto:info@inkfectioncollection.com">info@inkfectioncollection.com</a>. We will get back to you 
      with any adjustments that you might need to make to your images.
    </div>
  </div>
  <!-- <div class="row">
    <div class="col-6">
      <div class="stock-box">
        <a href="#" routerLink="/shop-stock">SHOP STOCK</a>
      </div>
    </div>
    <div class="col-6">
      <div class="custom-box">
        <a href="#" routerLink="/shop-custom">SHOP CUSTOM</a>
      </div>
    </div>
  </div> -->
</div>
